import { getCopyStatisticPrivate, getCopyStatisticPublic } from '@/controllers/gridManager/followerTransManager/followerTransManager';
import LineChartElement from '@/views/elements/chart/LineChartElement';
import TypographyElement from '@/views/elements/typography/TypographyElement';
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import styles from './CopyStatisticsChart.module.scss';
import { Stack } from '@mui/system';
import { useTheme } from '@mui/material';
import StateMenu from '@/views/components/StateMenu/StateMenu';
import { useTranslation } from 'react-i18next';

const cx = classNames.bind(styles);

type Props = {
    fullWidth?: boolean
    accountId: string,
    isPrivate?: boolean
}

export type TimeRanges = '1-M' | '3-M' | '6-M' | '1-Y'

export default function CopyStatisticsChart({ fullWidth, accountId, isPrivate }: Props) {
    const { t } = useTranslation()
    const theme = useTheme()
    const [dataSeries, setDataSeries] = useState<any>([])
    const [timeRange, setTimeRange] = useState<TimeRanges>('1-M');

    useEffect(() => {
        async function callApiDataChart() {
            const fn = isPrivate === true ? getCopyStatisticPrivate : getCopyStatisticPublic
            const [timePeriod, timeType] = timeRange.split('-')
            const { isSuccess, data } = await fn(accountId, timePeriod, timeType)
            const rs = data
            if (isSuccess) {

                setDataSeries(rs)
            }
        }
        setDataSeries([])
        callApiDataChart()
    }, [timeRange, accountId, isPrivate])

    return (
        <Stack spacing='15px' p='20px' className={cx("line-chart")}>
            <TypographyElement className={cx("title-chart")}>
                {t('copytrade.chart.copyStatistic.title')}
            </TypographyElement>
            <StateMenu currentState={timeRange} onStateChange={setTimeRange} menu={[
                { value: '1-M', label: t('copytrade.chart.timeRange.1m') },
                { value: '3-M', label: t('copytrade.chart.timeRange.3m') },
                { value: '6-M', label: t('copytrade.chart.timeRange.6m') },
                { value: '1-Y', label: t('copytrade.chart.timeRange.1y') },
            ]} />
            <Stack direction='row' justifyContent='space-between'>
                <TypographyElement ColorElement="secondary" FontSizeElement='12px'>{t('copytrade.chart.copyStatistic.people')}</TypographyElement>
                <TypographyElement ColorElement="secondary" FontSizeElement='12px'>{t('copytrade.chart.copyStatistic.total')}</TypographyElement>
            </Stack>
            <div className={cx("img-line-chart")}>
                <LineChartElement
                    series={[
                        {
                            id: 'copier_number',
                            marker: {
                                enabled: false
                            },
                            color: theme.palette.chart?.main,
                            name: t('copytrade.chart.copyStatistic.numOfCopying'),
                            tickInterval: 1,
                            yAxis: 0,
                        },
                        {
                            id: 'total_copy_amount',
                            color: theme.palette.chart?.violet,
                            marker: {
                                enabled: false
                            },
                            name: t('copytrade.chart.copyStatistic.totalValueCopying'),
                            yAxis: 1,
                        }
                    ]}
                    dataSeries={dataSeries}
                    height={null}
                    width={null}
                    timeRange={timeRange}
                    isShowYAxis={true}
                    isShowXAxis={true}
                    isShowLegend={true}
                />
            </div>
        </Stack>
    )
}